import React from 'react';
import BasePublishWebsiteModalContent from '../BaseModalContent/BasePublishWebsiteModalContent';
import { Button } from '@xo-union/tk-component-buttons';
import { DisplayLink } from '@xo-union/tk-ui-links';
import LinkButton from '../../../../LinkButton';
import MembershipApiService from '../../../../../services/membership-api/membership-api.service';
import styles from './VerifyEmailModalContent.scss';

interface GetANewLinkBottomContentProps {
  handleSendLink: () => Promise<void>;
}

const GetANewLinkBottomContent = ({ handleSendLink }: GetANewLinkBottomContentProps) => (
  <span>
    Don't see the email?{' '}
    <LinkButton color="secondary" onClick={handleSendLink} data-testid="VerifyEmailModalContent__GetNewLinkButton">
      Get a new link
    </LinkButton>
  </span>
);

const NeedHelpBottomContent = () => (
  <span>
    Need help?{' '}
    <DisplayLink
      target="_blank"
      href="https://helpcenter.theknot.com/hc/en-us"
      data-testid="VerifyEmailModalContent__ChatWithCustomerCareLink"
      color="secondary"
    >
      Chat with Customer Care
    </DisplayLink>
  </span>
);

interface VerifyEmailModalContentProps {
  userEmail?: string;
}

const VerifyEmailModalContent = ({ userEmail }: VerifyEmailModalContentProps) => {
  const [hasLinkBeenSent, setHasLinkBeenSent] = React.useState(false);
  const [hasLinkBeenSentASecondTime, setHasLinkBeenSentASecondTime] = React.useState(false);

  const handleSendLink = async () => {
    if (hasLinkBeenSent) {
      setHasLinkBeenSentASecondTime(true);
    } else {
      setHasLinkBeenSent(true);
    }

    await MembershipApiService.sendEmailVerification();
  };

  if (!hasLinkBeenSent) {
    return (
      <BasePublishWebsiteModalContent
        header="First, confirm your email"
        textContent={
          <div>
            <div>Before publishing, confirm your email using the link we will send to:</div>
            <div
              className={styles.VerifyEmailModalContent__EmphasizedText}
              data-testid="VerifyEmailModalContent__UserEmail"
            >
              [{userEmail}]
            </div>
          </div>
        }
        bottomContent={
          <Button size="md" onClick={handleSendLink} data-testid="VerifyEmailModalContent__SendLinkButton">
            Send link
          </Button>
        }
      />
    );
  }

  return (
    <BasePublishWebsiteModalContent
      header="Link sent!"
      textContent={
        <>
          <div>
            <div>Before publishing, confirm your email using the link we sent to:</div>
            <div
              className={styles.VerifyEmailModalContent__EmphasizedText}
              data-testid="VerifyEmailModalContent__UserEmail"
            >
              [{userEmail}]
            </div>
          </div>
          <div>
            After confirming,{' '}
            <LinkButton color="primary" onClick={() => window.location.reload()}>
              refresh this page
            </LinkButton>{' '}
            to continue working.
          </div>
        </>
      }
      bottomContent={
        !hasLinkBeenSentASecondTime ? (
          <GetANewLinkBottomContent handleSendLink={handleSendLink} />
        ) : (
          <NeedHelpBottomContent />
        )
      }
    />
  );
};

export default VerifyEmailModalContent;
